
/**********************************

Start Reload Cart Page with Live Inventory

***********************************/

    var firstChange = true;
        function reloadCart(){
        	var target = document.querySelector(`[data-subtotal]`);
        	if (!target)return
              var observer = new MutationObserver(function(mutations) {
                mutations.forEach(function(mutation) {
                  if (firstChange){
                  	firstChange = false;
                  	return;
                  } else{
                    	firstChange = true;
                  	 setTimeout(window.location.reload(),500);
                  }
                });    
              });
            var config = { attributes: true, childList: true, characterData: true };
            observer.observe(target, config);
            }
            document.addEventListener("DOMContentLoaded", function() {
              reloadCart();
            });
            selectElements = document.getElementsByClassName(`js-qty__adjust`);
            	var allOne = true;
            
            for (i = 0; i < selectElements.length; i++ ) {
            		if (selectElements[i].getAttribute("value") > 1) {
              		allOne = false;
            		}
            }
         console.log(allOne);
        if (allOne == true) {
        firstChange = false;
      }

/**********************************

End Reload Cart Page with Live Inventory

***********************************/